/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for TodoStatus controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_DEFAULT, CLIENT_CONTEXT_TOKEN_DEFAULT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { RequestOptions, GetTodoStatusByIdResponse, UpdateTodoStatusRequest, ReorderTodoStatusesRequest, GetTodoStatusSelectResponse, GetTodoStatusesResponse, CreateTodoStatusRequest, CreateTodoStatusResponse } from "../models";

@Injectable({ providedIn: "root" })
export class TodoStatusService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_DEFAULT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_DEFAULT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'default');
    }

    getTodoStatusById(id: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<GetTodoStatusByIdResponse>;
    getTodoStatusById(id: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<GetTodoStatusByIdResponse>>;
    getTodoStatusById(id: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<GetTodoStatusByIdResponse>>;
    getTodoStatusById(id: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/TodoStatus/${id}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }

    updateTodoStatus(id: number, updateTodoStatusRequest: UpdateTodoStatusRequest, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    updateTodoStatus(id: number, updateTodoStatusRequest: UpdateTodoStatusRequest, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    updateTodoStatus(id: number, updateTodoStatusRequest: UpdateTodoStatusRequest, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    updateTodoStatus(id: number, updateTodoStatusRequest: UpdateTodoStatusRequest, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/TodoStatus/${id}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.put(url, updateTodoStatusRequest, requestOptions);
    }

    deleteTodoStatus(id: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    deleteTodoStatus(id: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    deleteTodoStatus(id: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    deleteTodoStatus(id: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/TodoStatus/${id}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.delete(url, requestOptions);
    }

    reorderTodoStatuses(reorderTodoStatusesRequest: ReorderTodoStatusesRequest, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    reorderTodoStatuses(reorderTodoStatusesRequest: ReorderTodoStatusesRequest, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    reorderTodoStatuses(reorderTodoStatusesRequest: ReorderTodoStatusesRequest, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    reorderTodoStatuses(reorderTodoStatusesRequest: ReorderTodoStatusesRequest, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/TodoStatus/reorder`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.put(url, reorderTodoStatusesRequest, requestOptions);
    }

    getTodoStatusSelect(observe?: 'body', options?: RequestOptions<'json'>): Observable<GetTodoStatusSelectResponse>;
    getTodoStatusSelect(observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<GetTodoStatusSelectResponse>>;
    getTodoStatusSelect(observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<GetTodoStatusSelectResponse>>;
    getTodoStatusSelect(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/TodoStatus/Select`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }

    getTodoStatuses(observe?: 'body', options?: RequestOptions<'json'>): Observable<GetTodoStatusesResponse>;
    getTodoStatuses(observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<GetTodoStatusesResponse>>;
    getTodoStatuses(observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<GetTodoStatusesResponse>>;
    getTodoStatuses(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/TodoStatus`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }

    createTodoStatus(createTodoStatusRequest: CreateTodoStatusRequest, observe?: 'body', options?: RequestOptions<'json'>): Observable<CreateTodoStatusResponse>;
    createTodoStatus(createTodoStatusRequest: CreateTodoStatusRequest, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<CreateTodoStatusResponse>>;
    createTodoStatus(createTodoStatusRequest: CreateTodoStatusRequest, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<CreateTodoStatusResponse>>;
    createTodoStatus(createTodoStatusRequest: CreateTodoStatusRequest, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/TodoStatus`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.post(url, createTodoStatusRequest, requestOptions);
    }
}
